// @ts-nocheck
export const message = [
    import('CommonMessages/common-errorcode/en.json'),
    import('CommonMessages/account-login/en.json'),
    import('CommonMessages/common-country/en.json')
];
